module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjciIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAyNyAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41MDE0NjUiIHk9IjAuNSIgd2lkdGg9IjI2IiBoZWlnaHQ9IjIuNSIgcng9IjEiIGZpbGw9IiNGNkQ5QUEiLz4KPHJlY3QgeD0iMC41MDE0NjUiIHk9IjcuNTQ2ODgiIHdpZHRoPSIyNiIgaGVpZ2h0PSIyLjUiIHJ4PSIxIiBmaWxsPSIjRjZEOUFBIi8+CjxyZWN0IHg9IjAuNTAxNDY1IiB5PSIxNC41OTM4IiB3aWR0aD0iMjYiIGhlaWdodD0iMi41IiByeD0iMSIgZmlsbD0iI0Y2RDlBQSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TopBar/Menu.svg
// module id = NLYM
// module chunks = 0